import { Button, FilePicker } from '@veneer/core';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import './uploadmodal.css';
import {Trans,useTranslation} from 'react-i18next';
interface FileData {
    name: string;
    size: string;
    type: string;
    file: File;
    sizeValid: boolean;
}

interface UploadFileModalProps {
    onClose: () => void;
    onUpload: (files: File[]) => void;
    attachedFilesData: any;
    storeFileData: (files: any) => void;
    filesData: any;
    removeOneFiles?: any;
    totalfilesCount?:number|0;
}

const UploadFileModal: React.FC<UploadFileModalProps> = ({ attachedFilesData = {}, removeOneFiles, totalfilesCount, onClose, onUpload, storeFileData, filesData }) => {
    
    console.log(totalfilesCount, 'totalfilesCount.....');

    const [fileData, setFileData] = useState<FileData[]>(filesData || []);
    const allowedFormats = [
        ".jpeg", ".jpg", ".png", ".doc",
        ".docx", ".ppt", ".pptx", ".xls",
        ".xlsx", ".csv", ".txt", ".pdf",
        ".zip", ".gif", ".bmp", ".tgz",
        ".tar", ".cfg", ".log", ".pbu",
        ".cap", ".pcap", ".dmp", ".gz",
        ".msg", ".gzip", ".m4a", ".m4v",
        ".mov", ".mp3", ".mp4"
    ];
    const maxFiles = 3;
    const maxFileSize = sessionStorage.getItem("isPoly") === 'true' ? 2 * 1024 * 1024 * 1024 : 32 * 1024 * 1024;

    const removeFile = (index: number) => {
        setFileData(prev => prev.filter((_, i) => i !== index));
        removeOneFiles();
    };
    const { t } = useTranslation();

    const validateFiles = (files: FileList): FileData[] => {
        return Array.from(files).map(file => ({
            name: file.name,
            size: (file.size / (1024 * 1024)).toFixed(2),
            type: file.type,
            file,
            sizeValid: file.size <= maxFileSize,
        }));
    };

    const changeFileHandle = (event: React.ChangeEvent<HTMLInputElement>, name: any) => {
    
        const files = event.target.files;
        if (!files) return;

        const selectedFiles: FileData[] = validateFiles(files);

        console.log('totalfilesCount....', totalfilesCount);
        console.log(selectedFiles, 'selectedFiles....');
        console.log(fileData, 'fileData....')
    
        const totalSelectedFiles = (totalfilesCount ?? 0);

        if (totalSelectedFiles > 2) {
            toast.error(t('HPI.ErrorMessage.YouCanUploadMaximumOf3Files.',{defaultValue:'You can upload a maximum of 3 files.'}));
            event.target.value = ""; // Reset file input
            return;
        }

        const unSupported = selectedFiles.filter((f) => {
            const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
            return !allowedFormats.includes(extension);
        });

        if (unSupported.length > 0) {
            toast.error(t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats',{defaultValue:'Some files have unsupported formats'}));
            event.target.value = ""; // Reset file input
            return;
        }

        const validExtensions = selectedFiles.filter((f) => {
            const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
            return allowedFormats.includes(extension);
        });

        if (validExtensions.length > selectedFiles.length) {
            toast.error(t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats',{defaultValue:'Some files have unsupported formats'}));
            event.target.value = "";
            return;
        }
        const validFiles = validExtensions.filter((f) => f.sizeValid);
        if (validFiles.length < validExtensions.length) {
            toast.error(t('HPI.ErrorMessage.SomeFilesExceed2MBSize',{defaultValue:'Some files exceed the 32MB size'}));
            event.target.value = "";
            return;
        }
    
        setFileData(prevFiles => [...prevFiles, ...selectedFiles]);
        event.target.value = "";
    };
    

    useEffect(()=>{
        onUpload(fileData.map(f => f.file));
        storeFileData(fileData);
    }, [fileData])

    const handleOk = () => {
        onClose();
    };

    return (
        <div>
            <div className="col-md-6 mt-2 uploadFilePicker_Div textbox input-container">
                <FilePicker
                    id="file-picker"
                    // multiple
                    name="upload_File"
                    className="Upload_attachment textbox"
                    onChange={changeFileHandle}
                    accept={allowedFormats.join(",")}
                    placeholder={t('HPI.Profilepage.UploadFile',{defaultValue:'Upload File'})}
                    label={t('HPI.Profilepage.UploadFile',{defaultValue:'Upload File'})}
                />
            </div>
            <div>
                {fileData?.length > 0 && (
                    <ul style={{ paddingLeft: '0px' }}>
                        {fileData.map((f, index) => (
                            <li key={index} style={{ display: "flex", alignItems: "center" }}>
                                <span>{`${f.file.name} (${f.size}MB)`}</span>
                                <button
                                    type="button"
                                    onClick={() => removeFile(index)}
                                    className="remove-file-btn"
                                >
                                    X
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
            <div className="Upload_OkDIV">
                <Button onClick={handleOk}>{t("HPI.Ok",{defaultValue:'OK'})}</Button>
            </div>
        </div>
    );
};

export default UploadFileModal;